import { Dispatch, ReactNode, SetStateAction, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, Collapse } from "reactstrap";

interface Props {
  title: ReactNode;
  subtitle: ReactNode;
  startOpen?: boolean;
  options?: ReactNode;
  children?: ReactNode;
  link?: string;
  className?: string;
  providedOpen?: boolean;
  providedSetOpen?: Dispatch<SetStateAction<boolean>>;
}

const CollapseCard = ({
  title,
  subtitle,
  startOpen = false,
  options,
  children,
  link,
  className,
  providedOpen,
  providedSetOpen,
}: Props) => {
  const [openState, setOpenState] = useState(startOpen);
  const open = providedOpen !== undefined ? providedOpen : openState;
  const setOpen =
    providedSetOpen !== undefined ? providedSetOpen : setOpenState;

  const CollapsibleCard = (
    <Card className={`shadow ${className}`}>
      <CardHeader>
        <div className="d-flex align-items-center justify-content-between">
          <div
            className="d-flex align-items-center cursor-pointer"
            onClick={link ? undefined : () => setOpen((prev) => !prev)}
          >
            <i
              className={`mdi mdi-chevron-${open ? "down" : "right"} mr-3`}
              style={{ fontSize: 22 }}
            />
            <div>
              <h3 className="mb-0 pr-4 mb--1">{title}</h3>
              <small className="text-medium">{subtitle}</small>
            </div>
          </div>
          {open && options}
        </div>
      </CardHeader>
      <Collapse isOpen={open}>{children}</Collapse>
    </Card>
  );

  if (!link) return CollapsibleCard;

  return <Link to={link}>{CollapsibleCard}</Link>;
};

export default CollapseCard;
